<template>
  <span v-if="visible" class="task-widget-checklist-progress" :class="'task-widget-checklist-progress--' + progressStatus" :title="'Checklist: ' + normalizedProgress + '%'" :aria-label="'Avance del checklist: ' + normalizedProgress + '%'">
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle class="task-widget-checklist-progress__track" cx="12" cy="12" r="9" pathLength="100" />
      <circle class="task-widget-checklist-progress__value" cx="12" cy="12" r="9" pathLength="100" :stroke-dasharray="normalizedProgress + ' 100'" />
      <text x="12" y="12.5">{{ normalizedProgress }}</text>
    </svg>
  </span>
</template>

<script>
export default {
  name: 'TaskChecklistProgress',
  props: {
    progress: { type: [Number, String], default: null },
    status: { type: String, default: '' },
  },
  computed: {
    visible() { return this.progress !== null && this.progress !== undefined && this.progress !== '' },
    normalizedProgress() { return Math.max(0, Math.min(100, Number(this.progress) || 0)) },
    progressStatus() {
      if (this.status) return this.status
      if (this.normalizedProgress === 0) return 'empty'
      if (this.normalizedProgress === 100) return 'complete'
      return 'partial'
    },
  },
}
</script>

<style scoped>
.task-widget-checklist-progress { display: inline-flex; flex: 0 0 auto; width: 25px; height: 25px; }
.task-widget-checklist-progress svg { width: 100%; height: 100%; transform: rotate(-90deg); }
.task-widget-checklist-progress circle { fill: none; stroke-width: 3; }
.task-widget-checklist-progress__track { stroke: var(--app-color-border); }
.task-widget-checklist-progress__value { stroke: var(--app-color-warning); stroke-linecap: round; }
.task-widget-checklist-progress--empty .task-widget-checklist-progress__value { stroke: var(--app-color-danger); }
.task-widget-checklist-progress--complete .task-widget-checklist-progress__value { stroke: var(--app-color-success); }
.task-widget-checklist-progress text { fill: var(--app-color-text-secondary); font-size: 7px; font-weight: 800; text-anchor: middle; dominant-baseline: middle; transform: rotate(90deg); transform-origin: center; }
</style>
